import React, { useState, useEffect, useRef } from "react";
import "./Assessts/Styles/PrincipleDashboard.scss";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
// Below is for import the components
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import ParticipationGroupchart from "./ParticipationGroupchart";
import {
  AssessmentName,
  NumberToRoman,
} from "../Student/Reusablecomponents/RegularFunctions";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../Student/Reusablecomponents/Loading";
import { useSelector } from "react-redux";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Grade } from "../Student/Reusablecomponents/RegularFunctions";

import { DownloadGraphImage } from "../ReusableComponents/CommonFunctions";
import {
  DownloadGraphButton,
  ExportXlButton,
} from "../ReusableComponents/CommonComponents";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { DownloadExcel } from "../ReusableComponents/CommonFunctions";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../ReusableComponents/CommonApis";
const PrincipleParticipation = () => {
  // const navigate = useNavigate();
  const chartRef = useRef(null);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const [SGWParticipationR, SetSGWParticipationR] = useState();
  const [SelectClasses, SetSelectClasses] = useState();
  const [Sections, SetSections] = useState();
  const [Load, SetLoad] = useState(false);

  const [SList, SetSList] = useState({
    data: "",
    Type: "",
  });

  const SubjectGradeWiseParticipationReport = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/Principal/GetSubjectGradeWiseParticipationReport?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetLoad((prev) => !prev);
        if (res.data[0].grade) {
          SetSGWParticipationR(res.data);
          const StoreClasses = res.data.map((Class) => Class.grade);
          SetSelectClasses(StoreClasses[0]);

          const sections = res.data.reduce((acc, current) => {
            Object.keys(current).forEach((key) => {
              if (
                key.includes("_") &&
                !acc.includes(key.split("_")[0].slice(3))
              ) {
                acc.push(key.split("_")[0].slice(3));
              }
            });
            return acc;
          }, []);
          SetSections(sections);
        } else {
          SetSGWParticipationR(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SelectDate?.value > 0) {
      SubjectGradeWiseParticipationReport();
      GetAssmentdates();
    }else{
      SetSGWParticipationR(process.env.REACT_APP_NODATAFOUND_Participated);
    }
  }, [SelectDate]);
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(items?.instituteId, SelectDate, USYear?.value,items?.userId);
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(
      Grades?.map((grade) => ({
        display: `Grade ${grade}`,
        value: grade.trim(),
      }))
    );
  };
  const GetPColor = (e) => {
    const colors = {
      A: "#3DA663",
      B: "#7C60BC",
      C: "#3B9ED7",
      D: "#F7C66A",
      X: "#109CB0",
    };
    return colors[e] || "#F59E3C";
  };

  const StudentsList = async (LisType, Grade) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/Principal/GetGradeOrSectionwiseParticipationList?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&Grade=${Grade}&Section=All&AssessmentType=${SelectDate?.assessmentType}&IsAttended=${LisType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetSList({
          data: res.data,
          Type: LisType === 1 ? "Attended" : "Unattended",
          Grade: Grade,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const SListColumns = [
    { name: "Student Id", selector: "studentId", sortable: true },
    { name: "Student Name", selector: "studentName", sortable: true },
    { name: "Section", selector: "section", sortable: true },
  ];
  const DownloadGraph = (e) => {
    DownloadGraphImage(
      chartRef,
      `Section wise participation of ${AssessmentName(
        SelectDate?.assessmentType
      )} Grade ${SelectClasses} - ${SelectDate?.examStartDate} `
    );
  };

  const DownloadTables = async (
    Data,
    Subjects,
    Sections,
    Filename,
    HeaderName
  ) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Grades");

    // Step 1: Add heading (merged row)
    const totalColumns = 2 + Subjects.length * Sections.length;
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const headingCell = worksheet.getCell("A1");
    headingCell.value = HeaderName;
    headingCell.font = { bold: true, size: 16 };
    headingCell.alignment = { vertical: "middle", horizontal: "center" };

    // Step 2: Create header rows
    const headerRow1 = ["S.No", "Grade"];
    const headerRow2 = ["", ""];
    Subjects.forEach((subject) => {
      headerRow1.push(
        `Section - ${subject}`,
        ...Array(Sections.length - 1).fill("")
      );
      Sections.forEach((lvl) => headerRow2.push(lvl.toUpperCase()));
    });

    worksheet.addRow(headerRow1);
    worksheet.addRow(headerRow2);
    [2, 3].forEach((rowNum) => {
      worksheet.getRow(rowNum).eachCell((cell) => {
        cell.font = { bold: true };
      });
    });
    // Step 3: Merge subject headers
    worksheet.mergeCells(2, 1, 3, 1);
    worksheet.mergeCells(2, 2, 3, 2);
    // 2. Dynamically merge subject headers
    let startCol = 3; // Start after Grade column
    Subjects.forEach((subject) => {
      // const levelCount = ;
      const endCol = startCol + Sections.length - 1;
      worksheet.mergeCells(2, startCol, 2, endCol); // Merge for subject name in Row 2
      startCol = endCol + 1; // Move to next subject group
    });

    // Step 4: Add student data
    Object.values(Data).forEach((entry, index) => {
      const row = [index + 1, NumberToRoman(entry.grade)];
      Subjects.forEach((subject) => {
        Sections.forEach((lvl) => {
          let val;
          if (lvl === "Registered") {
            val = entry[`sec${subject}_Registrated`];
          } else if (lvl === "Attended") {
            val = entry[`sec${subject}_Participated`];
          } else if (lvl === "Attended%") {
            val = Math.round(
              (entry[`sec${subject}_Participated`] /
                entry[`sec${subject}_Registrated`]) *
                100
            );
          }
          row.push(val > 0 ? val : "-");
        });
      });
      worksheet.addRow(row);
    });

    // Step 5: Center align all cells and add borders
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Step 6: Adjust column widths
    worksheet.columns.forEach((col) => {
      col.width = 11;
    });

    // Step 7: Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${Filename}.xlsx`);
  };
  const DownloadTPTable = (Data, FileName, SheetName, Heading) => {
    const XL = Data?.map((item, index) => {
      return {
        SNo: index + 1,
        "Student Id": item.studentId,
        "Student Name": item.studentName,
        Section: item.section,
      };
    });
    DownloadExcel(XL, FileName, false, SheetName, Heading, true);
  };
  const DownloadTotalparticipation = () => {
    const XL = SGWParticipationR?.map((item, index) => {
      return {
        SNo: index + 1,
        Grade: NumberToRoman(item.grade),
        Registered: item.registered,
        Attended: item.participated,
        Unattended: item.unattended,
        "Attended %": `${Math.round(
          (item.participated / item.registered) * 100
        )}%`,
      };
    });
    const totalRegistered = SGWParticipationR.reduce(
      (sum, item) => sum + item.registered,
      0
    );
    const totalParticipated = SGWParticipationR.reduce(
      (sum, item) => sum + item.participated,
      0
    );
    const totalUnattended = SGWParticipationR.reduce(
      (sum, item) => sum + item.unattended,
      0
    );
    const totalPercent = `${Math.round(
      (totalParticipated / totalRegistered) * 100
    )}%`;

    // Add totals row to Excel data
    XL.push({
      SNo: SGWParticipationR?.length + 1,
      Grade: "Total",
      Registered: totalRegistered,
      Attended: totalParticipated,
      Unattended: totalUnattended,
      "Attended %": totalPercent,
    });
    DownloadExcel(
      XL,
      `${AssessmentName(SelectDate?.assessmentType)} - ${
        SelectDate?.examStartDate
      } - Total participation`,
      false,
      "Total participation",
      `${AssessmentName(SelectDate?.assessmentType)} - ${
        SelectDate?.examStartDate
      } - Total participation`,
      true
    );
  };
  return (
    <>
      <div className="TeacherBgImage dflex flexd-column principle-maindiv">
        <InternetChecking />
        <div className="MainHeading">
          Section wise participation Grades I to XII{" "}
          {AssessmentName(SelectDate?.assessmentType)} -{" "}
          {SelectDate?.examStartDate}
        </div>
        <div className="dflex JSBetween alignitems ">
          <div></div>
          <div className="dflex gap-3">
            {SGWParticipationR?.[0]?.grade && (
              <ExportXlButton
                Name="Export to Excel"
                Click={() =>
                  DownloadTables(
                    SGWParticipationR,
                    Sections,
                    ["Registered", "Attended", "Attended%"],
                    `Section wise participation Grades I to XII ${AssessmentName(
                      SelectDate?.assessmentType
                    )} - ${SelectDate?.examStartDate} `,
                    `Section wise participation Grades I to XII ${AssessmentName(
                      SelectDate?.assessmentType
                    )} - ${SelectDate?.examStartDate} `
                  )
                }
              />
            )}
          </div>
        </div>
        {SGWParticipationR?.[0]?.grade ? (
          <>
            <Row>
              <Col className="Table-Card p-0">
                {/* <div > */}
                <table className="Principle-Table">
                  <thead>
                    <tr>
                      <th rowSpan="2" className="fw-bold">
                        Grade
                      </th>
                      {Sections?.map((Sec, index) => (
                        <th
                          colSpan="3"
                          key={index}
                          style={{
                            backgroundColor: GetPColor(Sec),
                            color: "#FFF",
                          }}
                        >
                          {" "}
                          Section - {Sec}
                        </th>
                      ))}
                    </tr>
                    <tr>
                      {Sections?.flatMap((Sec, Sectionindex) =>
                        ["Registered", "Attended", "Attended %"].map(
                          (Attedence, Attendenceindex) => (
                            <th
                              key={`Attedence-${Sectionindex}-${Attendenceindex}`}
                              style={{ color: GetPColor(Sec) }}
                            >
                              {Attedence}
                            </th>
                          )
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {SGWParticipationR?.map((item, index) => (
                      <tr key={index}>
                        {" "}
                        <td className="fw-bold">
                          {" "}
                          {NumberToRoman(item.grade)}
                        </td>
                        {Sections?.flatMap((Sec, Sectionindex) => (
                          <>
                            <td key={`Registrated-${Sectionindex}`}>
                              {item[`sec${Sec}_Registrated`]
                                ? item[`sec${Sec}_Registrated`]
                                : "-"}
                            </td>
                            <td key={`Participated-${Sectionindex}`}>
                              {item[`sec${Sec}_Participated`]
                                ? item[`sec${Sec}_Participated`]
                                : "-"}
                            </td>
                            <td key={`ParticipatedPercentage-${Sectionindex}`}>
                              {" "}
                              {item[`sec${Sec}_Registrated`] &&
                              Math.round(
                                (item[`sec${Sec}_Participated`] /
                                  item[`sec${Sec}_Registrated`]) *
                                  100
                              )
                                ? Math.round(
                                    (item[`sec${Sec}_Participated`] /
                                      item[`sec${Sec}_Registrated`]) *
                                      100
                                  )
                                : "-"}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>

            <Row className="dflex gap-3">
              <Col className="Card">
                <div className="dflex JSBetween alignitems">
                  <div className="SubHeading">Total participation</div>
                  <ExportXlButton
                    Name="Export to Excel"
                    Click={() => DownloadTotalparticipation()}
                  />
                </div>

                <table className="Principle-Table mt-4">
                  <thead>
                    <tr>
                      <th className="fw-bold">Grade</th>
                      <th className="fw-bold">Registered</th>
                      <th className="fw-bold">Attended</th>
                      <th className="fw-bold">Unattended</th>
                      <th className="fw-bold">Attended %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SGWParticipationR.map((item, index) => (
                      <tr key={index}>
                        <td className="fw-bold">{NumberToRoman(item.grade)}</td>
                        <td>{item.registered}</td>
                        <td
                          className="LinkStyles"
                          onClick={() => StudentsList(1, item.grade)}
                        >
                          {item.participated}
                        </td>
                        <td
                          className="LinkStyles"
                          onClick={() => StudentsList(0, item.grade)}
                        >
                          {item.unattended}
                        </td>
                        <td>
                          {Math.round(
                            (item.participated / item.registered) * 100
                          ) || 0}
                        </td>
                      </tr>
                    ))}
                    <tr style={{ backgroundColor: "red" }}>
                      <td className="fw-bold">Total</td>
                      <td className="fw-bold">
                        {SGWParticipationR.reduce(
                          (sum, item) => sum + item.registered,
                          0
                        )}
                      </td>
                      <td className="fw-bold">
                        {SGWParticipationR.reduce(
                          (sum, item) => sum + item.participated,
                          0
                        )}
                      </td>
                      <td className="fw-bold">
                        {SGWParticipationR.reduce(
                          (sum, item) => sum + item.unattended,
                          0
                        )}
                      </td>
                      <td className="fw-bold">
                        {Math.round(
                          (SGWParticipationR.reduce(
                            (sum, item) => sum + item.participated,
                            0
                          ) /
                            SGWParticipationR.reduce(
                              (sum, item) => sum + item.registered,
                              0
                            )) *
                            100
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* </div> */}
              </Col>
              <Col className="Card">
                {/* <div className="Card"> */}
                <div className="dflex alignitems JSBetween">
                  <div className="SubHeading">
                    Section wise participation (Grades l- Xll)
                  </div>
                  <div className="dflex gap-3">
                    {/* <Grade
                      PostGrade={SetSelectClasses}
                      className="NCLDropdown"
                      selected={"Grade " + SelectClasses}
                    /> */}
                    <DropdownValues
                      className="NCLDropdown"
                      options={ASSGrade}
                      selectoption={SelectClasses}
                      Displayname="Select Grade"
                      onChange={(e) => SetSelectClasses(e.target.value)}
                    />

                    <DownloadGraphButton Click={() => DownloadGraph()} />
                  </div>
                </div>

                {SGWParticipationR.filter(
                  (grade) => grade.grade === parseInt(SelectClasses)
                ).length > 0 ? (
                  <div className="dflex JSAround">
                    <div className="w-100">
                      <ParticipationGroupchart
                        Ref={chartRef}
                        Participation={SGWParticipationR}
                        SelectGrade={parseInt(SelectClasses)}
                        Labels={Sections}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="ErrorMessage">
                    {SGWParticipationR &&
                      process.env.REACT_APP_NODATAFOUND_Participated}
                  </div>
                )}
              </Col>
            </Row>
            {/* <CopyRight /> */}
          </>
        ) : (
          <div className="ErrorMessage">{SGWParticipationR}</div>
        )}
      </div>

      {SList?.data && (
        <div className="Model-Open">
          <div className="Card w-100 pt-4">
            <div className="MainHeading">
              {" "}
              {SList?.Type} Students for{" "}
              {AssessmentName(SelectDate?.assessmentType)} -{" "}
              {SelectDate?.examStartDate} (Grade - {NumberToRoman(SList?.Grade)}
              )
            </div>
            <IoMdCloseCircleOutline
              className="DetailsClose CPointer"
              onClick={() => SetSList()}
            />
            <div className="dflex JSBetween mb-2">
              <div></div>
              <ExportXlButton
                Name="Export to Excel"
                Click={() =>
                  DownloadTPTable(
                    SList?.data,
                    `${SList?.Type} Students for ${AssessmentName(
                      SelectDate?.assessmentType
                    )}
                    }
              - ${SelectDate?.examStartDate} (Grade - ${NumberToRoman(
                      SList?.Grade
                    )})`,
                    `${SList?.Type} Students for ${AssessmentName(
                      SelectDate?.assessmentType
                    )}
                    }
              - ${SelectDate?.examStartDate}`,
                    `${SList?.Type} Students for ${AssessmentName(
                      SelectDate?.assessmentType
                    )}
                    }
              - ${SelectDate?.examStartDate} (Grade - ${NumberToRoman(
                      SList?.Grade
                    )})`
                  )
                }
              />
            </div>

            <DataTable
              data={SList?.data}
              columns={SListColumns}
              className="NCLDataTable"
              Dropdownvalues={["10", "25"]}
              ShowPagination="true"
            />
          </div>
        </div>
      )}

      {Load && <Loading />}
    </>
  );
};

export default PrincipleParticipation;
